export default __webpack_public_path__ + "static/media/transfer_call.04282de3.svg";